// ============================================
// PROVIDER-AGNOSTIC INTERFACE
// ============================================
// This file defines selectors and actions that work with any provider.
// The store.js conditionally loads the correct provider-specific slices
// into state.game and state.spin, so these selectors just access the state.
//
// All provider-specific slices must follow the same state shape contract.

// ============================================
// SPIN SELECTORS
// ============================================
// These selectors access state.spin, which is populated by the provider-specific slice
export const selectIsSpinning = (state) => state.spin.isSpinning;
export const selectSpinComplete = (state) => state.spin.spinComplete;
export const selectWindupComplete = (state) => state.spin.windupComplete;
export const selectManualStop = (state) => state.spin.manualStop;
export const selectReelsFrozen = (state) => state.spin.reelsFrozen;

// ============================================
// GAME SELECTORS
// ============================================
// These selectors access state.game, which is populated by the provider-specific slice
export const selectSessionExpired = (state) => state.game.sessionExpired;
export const selectCurrentRound = (state) => state.game.currentRound;
export const selectWinningLines = (state) => state.game.winningLines;
export const selectScatterCount = (state) => state.game.currentRound?.scatterCount || 0;
export const selectScatterPositions = (state) => state.game.currentRound?.scatterPositions || [];
export const selectWinType = (state) => state.game.currentRound?.winType || "";
export const selectBalance = (state) => state.game.balance;
export const selectBet = (state) => state.game.bet;
export const selectPaytable = (state) => state.game.paytable;
export const selectCurrency = (state) => state.game.currency;
export const selectCurrencyConfig = (state) => state.game.currencyConfig;
export const selectBonusBuyMultiplier = (state) =>
  state.game.bonusBuyMultiplier;
export const selectDisplayedBalance = (state) => state.game.displayedBalance;
export const selectBets = (state) => state.game.bets;
export const selectGameStatus = (state) => state.game.status;
export const selectAssetsStatus = (state) => state.assets.status;

// Universal state selectors (provider-agnostic)
export const selectGameMode = (state) => state.game.gameMode;
export const selectFeatureState = (state) => state.game.featureState;
export const selectReloadState = (state) => state.game.reloadState;

// Legacy provider-specific selectors (kept for backward compatibility)
export const selectAvailableActions = (state) => state.game.availableActions;
export const selectFlowState = (state) => state.game.flowState;
export const selectFeatures = (state) => state.game.features; // PopiPlay respin features: {respins_issued, respins_left, trigger_screen}
export const selectLastCommand = (state) => state.game.lastCommand;
export const selectErrorCode = (state) => state.game.errorCode; // API error code (e.g., 205, 301)
